import React from "react";

import { Label } from "@client/shadcn/ui/label";

interface Props {
    className?: string;
}

export const HeroSection = (props: Props) => {
    return (
        <section className="flex flex-col items-center my-20 mx-12 text-center gap-6">
            <Label className="text-5xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-transparent bg-clip-text">
                ELT AI Incubation Portal
            </Label>
            <Label className="text-xl">Welcome to the ELT AI Incubation Portal.</Label>
            <Label className="text-lg text-gray-300 mb-12 gap-0 inline">
                This platform is designed to help manage and track AI incubation projects for&nbsp;
                <a href="https://global.oup.com/" className="text-blue-400 hover:underline">
                    Oxford University Press
                </a>.
            </Label>
        </section>
    );
};
